import axios from 'axios'

// initial state
const state = () => ({
  questionnaire: null,
})

// getters
const getters = {
  questionnaire: state => {
    return state.questionnaire
  },
}

// actions
const actions = {
  async fetchQuestionnaire ({commit, state}, slug) {
    try {
      const response = await axios.get(`${'/questionnaires/' + slug}`);
      commit('SET_QUESTIONANAIRE', response.data);
    } catch (error) {
      reject(error); 
    }
  },
  clearQuestionnaire ({commit, state}) {
    commit('CLEAR')
  },
  setSection({commit, state}, int) {
    commit('SET_CURRENT_SECTION', int)
  },

}

// mutations
const mutations = {
  LOAD: state => {
    if (localStorage.getItem('questionnaire')) {
      state.questionnaire = JSON.parse(localStorage.getItem('questionnaire'))
    }
    if (localStorage.getItem('currentSection')) {
      state.currentSection = parseInt(localStorage.getItem('currentSection'))
    }
  },
  SET_QUESTIONANAIRE: (state, questionnaire) => {
    state.questionnaire = questionnaire
    localStorage.setItem('questionnaire', JSON.stringify(state.questionnaire))
  },
  CLEAR: state => {
    state.questionnaire = null
    state.currentSection = null
    localStorage.removeItem('questionnaire')
    localStorage.removeItem('currentSection')
  },
  SET_CURRENT_SECTION: (state, int) => {
    state.currentSection = int
    localStorage.setItem('currentSection', int)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}